var _foreignObject, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBandit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("switch", null, _foreignObject || (_foreignObject = /*#__PURE__*/React.createElement("foreignObject", {
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M305 305H184.56l-6.866-30.319-22.486 21.903-12.792-43L94.842 307.1l-8.315-81.71-41.489 44.042L45 45h260z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277 277h-60.737l14.154-30.417-37.194 38.083-9.222-37.778-23.667 25.278-13.161-44.853L103 277.01l-8.111-80.177L73 219.802V73h204z",
    style: {
      fill: "#fbbb3f"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m243.667 3.75 65.944 33.528L183.25 238.625 161 186.5l-58 90.51 59.444-181.954 20.778 35.111z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M254.353 9.183 298.15 31.45 184.021 215.895l-19.91-54.34-54.403 101.715 54.375-145.326 19.972 33.611z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBandit);
export default __webpack_public_path__ + "static/media/bandit.b138130cb75e43569fe1bfa43da9caae.svg";
export { ForwardRef as ReactComponent };